/* eslint-disable no-undef */

interface ValidatorMetaData {
  model: {
    additionalAttributes: {
      regexExpression: string | RegExp;
    };
    message: string;
  };
}

interface ResultItem {
  isValid: boolean;
  message: string;
}

interface WorkingFormInfo {
  DependencyInactiveElements: unknown[];
  ValidationInfo: unknown;
}

const FormsExtend = (function () {
  function init() {
    if (
      typeof window.epi === "undefined" ||
      typeof window.epi.EPiServer === "undefined" ||
      typeof window.epi.EPiServer.Forms === "undefined"
    ) {
      return;
    }
    if (typeof $ === "undefined") {
      console.error("Forms cannot work without jQuery");
      return;
    }

    // Validate form fields on focusout
    $(".ValidationRequired").on("focusout", function () {
      validateField($(this));
    });

    // Validate file upload on change
    $(".js-fileContainer-input").on("change", function () {
      validateField($(this).closest(".FormFileUpload "));
    });

    $.extend(true, window.epi.EPiServer.Forms, customValidators);
    handleRollCageValidation();
  }

  // Check if an input element is valid or not
  function validateField($this: JQuery<HTMLElement>) {
    const $workingForm =
      window.epi.EPiServer.Forms.Utils.getWorkingFormFromInnerElement($this);
    const workingFormGuid =
      window.epi.EPiServer.Forms.Utils.getFormIdentifier($workingForm);
    const workingFormInfo = window.epi.EPiServer.Forms[workingFormGuid];
    workingFormInfo.$workingForm = $workingForm;
    return validateElement($this, workingFormInfo);
  }

  // Validate a field using epi.EPiServer.Forms and the applied validators
  // (this function is copied from EPiServer js implementation as it's not exposed for custom use)
  function validateElement(
    element: JQuery<HTMLElement>,
    workingFormInfo: WorkingFormInfo,
  ) {
    const $element = $(element);
    const $messageContainer = getValidationMessage($element);
    const elementName =
      window.epi.EPiServer.Forms.Utils.getElementName($element);
    const elementIdentifier = $element.attr("id") || elementName;
    const validators =
      window.epi.EPiServer.Forms.Validation.getElementValidators(
        workingFormInfo.ValidationInfo,
        elementIdentifier,
      );
    let isValid = true;

    $element.removeClass("ValidationFail ValidationSuccess");
    $element.parent().removeClass("ValidationFail ValidationSuccess");
    $messageContainer.hide();

    const elementValue =
      window.epi.EPiServer.Forms.Utils.getElementValue($element);

    if (
      workingFormInfo.DependencyInactiveElements.indexOf(elementName) < 0 &&
      validators instanceof Array &&
      validators.length > 0
    ) {
      const results = window.epi.EPiServer.Forms.Validation.validateFormValue(
        elementName,
        elementValue,
        validators,
      );
      const invalidResultItems = $.grep(results, function (item: ResultItem) {
        return item.isValid === false;
      });

      if (invalidResultItems && invalidResultItems.length > 0) {
        const messages = $.map(invalidResultItems, function (item: ResultItem) {
          return item.message;
        });

        $element.addClass("ValidationFail");
        $element.parent().addClass("ValidationFail");
        $messageContainer.text(messages.join(" ")).show();

        isValid = false;
      } else {
        $element.addClass("ValidationSuccess");
        $element.parent().addClass("ValidationSuccess");
        isValid = true;
      }
    }

    window.epi.EPiServer.Forms.Utils.raiseFormsEvent(workingFormInfo, {
      type: "elementValidated",
      isValid,
      elementName,
      elementValue,
      elementIdentifier,
      element,
      $messageContainer,
    });
    return isValid;
  }

  function setupRollCageListener(step: number) {
    const stepNextButton = document.querySelector(
      `[data-epiforms-stepindex="${step}"] .btnNext`,
    );
    const stepHeader = document.querySelectorAll(".FormStep")[step];
    if (stepNextButton && stepHeader) {
      stepNextButton.addEventListener("click", function () {
        $(stepHeader).addClass("ValidationSuccess");
        $(stepHeader).parent().addClass("ValidationSuccess");
      });
    }
  }

  function handleRollCageValidation() {
    setupRollCageListener(0);
    setupRollCageListener(1);
  }

  // (this function is copied from EPiServer js implementation as it's not exposed for custom use)
  function getValidationMessage($element: JQuery<HTMLElement>) {
    const elementName =
      window.epi.EPiServer.Forms.Utils.getElementName($element);
    const selector1 = window.epi.EPiServer.Forms.Utils.stringFormat(
      "{0}[data-epiforms-linked-name='{1}'], {0}[data-epiforms-linked-name='{2}']",
      [".Form__Element__ValidationError", elementName, $element.attr("id")],
    );
    const selector2 = window.epi.EPiServer.Forms.Utils.stringFormat(
      "{0}[data-f-linked-name='{1}'], {0}[data-f-linked-name='{2}']",
      ["[data-f-validationerror]", elementName, $element.attr("id")],
    );
    return $(selector1).add(selector2);
  }

  // takes the form field value and returns true on valid number
  const validateLuhn = function (value: string) {
    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;

    // The Luhn Algorithm. It's so pretty.
    let nCheck = 0;
    let bEven = false;
    value = value.replace(/\D/g, "");

    for (let n = value.length - 1; n >= 0; n--) {
      const cDigit = value.charAt(n);
      let nDigit = parseInt(cDigit, 10);

      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return nCheck % 10 === 0;
  };

  const customValidators = {
    Validators: {
      "Axfood.Core.Models.Forms.Validators.CustomRegexValidator": function (
        fieldName: string,
        fieldValue: string,
        validatorMetaData: ValidatorMetaData,
      ) {
        if (fieldValue === undefined || fieldValue.length === 0) return true;

        const regex =
          validatorMetaData.model.additionalAttributes.regexExpression;
        if (regex === null) return true;
        const validationResult = fieldValue.search(regex) !== -1;
        return {
          isValid: validationResult,
          message: validatorMetaData.model.message,
        };
      },
      "Axfood.Core.Models.Forms.Validators.LettersAndHyphenOnlyValidator":
        function (
          fieldName: string,
          fieldValue: string,
          validatorMetaData: ValidatorMetaData,
        ) {
          if (fieldValue === undefined || fieldValue.length === 0) return true;

          const regex = /^[A-Öa-ö -]+$/;
          const validationResult = fieldValue.search(regex) !== -1;
          return {
            isValid: validationResult,
            message: validatorMetaData.model.message,
          };
        },
      "Axfood.Core.Models.Forms.Validators.OrganisationNumberValidator":
        function (
          fieldName: string,
          fieldValue: string,
          validatorMetaData: ValidatorMetaData,
        ) {
          if (fieldValue === undefined || fieldValue.length === 0) return true;

          const validationResult = validateLuhn(fieldValue);
          return {
            isValid: validationResult,
            message: validatorMetaData.model.message,
          };
        },
      "Axfood.Core.Models.Forms.Validators.PhoneNumberValidator": function (
        fieldName: string,
        fieldValue: string,
        validatorMetaData: ValidatorMetaData,
      ) {
        if (fieldValue === undefined || fieldValue.length === 0) return true;

        const regex = /^(\+)?[0-9- ]+$/;
        const validationResult = fieldValue.search(regex) !== -1;
        return {
          isValid: validationResult,
          message: validatorMetaData.model.message,
        };
      },
      "Axfood.Core.Models.Forms.Validators.PostalCodeValidator": function (
        fieldName: string,
        fieldValue: string,
        validatorMetaData: ValidatorMetaData,
      ) {
        if (fieldValue === undefined || fieldValue.length === 0) return true;

        const regex =
          /^((s-|S-){0,1}|(se-|SE-){0,1})[1-9]{1}[0-9]{2}\s?[0-9]{2}$/;
        const validationResult = fieldValue.search(regex) !== -1;
        return {
          isValid: validationResult,
          message: validatorMetaData.model.message,
        };
      },
      "Axfood.Core.Models.Forms.Validators.GeolocationValidator": function (
        fieldName: string,
        fieldValue: string,
        validatorMetaData: ValidatorMetaData,
      ) {
        if (fieldValue === undefined || fieldValue.length === 0) return true;

        const regex = /^((-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)$/;
        const validationResult = fieldValue.search(regex) !== -1;
        return {
          isValid: validationResult,
          message: validatorMetaData.model.message,
        };
      },
    },
  };

  return {
    init,
  };
})();

export default FormsExtend;
